import { createAsyncThunk } from '@reduxjs/toolkit'
import okHttp from '@helper/okHttp'
import { dict, order, getTypePrefix } from '@/api'

/**
 * 获取售后类型
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const getOrderDictInfoByTypeAction = createAsyncThunk(
    getTypePrefix(`${dict.getDictListUrl}_refund_type`),
    async (params) => await okHttp(dict.getDictListUrl, {
        method: 'GET',
        params: {
            ...params,
            type: 'refund_type'
        }
    })
)

/**
 * 订单类型
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const getOrderTypeAction = createAsyncThunk(
    getTypePrefix(`${dict.getDictListUrl}_order_type_refund`),
    async (params) => await okHttp(dict.getDictListUrl, {
        method: 'GET',
        params: {
            ...params,
            type: 'order_type'
        }
    })
)

/**
 * 获取售后单列表
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const queryRefundListAction = createAsyncThunk(
    getTypePrefix(order.queryRefundListUrl),
    async (params) => await okHttp(order.queryRefundListUrl, {
        method: 'POST',
	    ...params
    })
)

/**
 * 获取售后单详情
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const queryRefundDetailAction = createAsyncThunk(
    getTypePrefix(order.queryRefundDetailUrl),
    async (params) => await okHttp(order.queryRefundDetailUrl, {
        method: 'GET',
        params
    })
)

/**
 * 获取换货单详情
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const queryOrderExchangeDetailAction = createAsyncThunk(
    getTypePrefix(order.queryOrderExchangeDetailUrl),
    async (params) => await okHttp(order.queryOrderExchangeDetailUrl, {
        method: 'GET',
        params
    })
)

/**
 * 获取换货单物流信息
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const queryOrderExchangeLogisticsAction = createAsyncThunk(
    getTypePrefix(order.queryOrderExchangeLogisticsUrl),
    async (params) => await okHttp(order.queryOrderExchangeLogisticsUrl, {
        method: 'GET',
        params
    })
)
